import { environment } from 'src/environments/environment';
import { RedirectRoutes, Arguments, CustomPaymentType } from './ss-payment-types';
import { Payment } from 'payments-lib-types';

export const SS_LIB_CONFIG: Arguments.ConfigArgs = {
  serverUrl: environment.ss_host,
  cdnList: ['https://cdn2.softswiss.net'],
  mercuryo: {
    widgetId: 'c10dad70-9af4-46be-9825-862234190076',
  },
};

export const redirectRoutes = (action: Payment.Action, paymentType: CustomPaymentType): RedirectRoutes => {
  return {
    successUrl: location.origin + `/payments-status/${action}/success?paymentType=${paymentType}`,
    failureUrl: location.origin + `/payments-status/${action}/failure?paymentType=${paymentType}`,
    pendingUrl: location.origin + '/faq',
    supportUrl: location.origin + '/games',
  };
};

export const CUSTOM_ROUTES: RedirectRoutes = {};
